import type { BankAccountResource } from "../../bank-account";
import type { CountryResource } from "../../country";
import type { VariantResource } from "../../variant";
import type { PaymentMethodResource } from "../../payment-method";

export enum AccountingAccountTypeEnum {
  Receivables = "Receivables", // als "Forderungen" Konto für alle Kunden
  Payables = "Payables", // als "Verbindlichkeiten" Konto für alle Lieferanten
  RevenueDomestic = "RevenueDomestic", // als Erlöskonto für Inland
  Expenditure = "Expenditure", // als Ausgaben
  RevenueOther = "RevenueOther", // als sonstige Erlöse
  RevenueEuPrivate = "RevenueEuPrivate", // als Erlöskonto für EU (Privatperson)
  RevenueEuBusiness = "RevenueEuBusiness", // als Erlöskonto für Innergemeinschaftliche Lieferung
  RevenueNonEU = "RevenueNonEU", // als Erlöskonto für nicht EU
  VatDomestic = "VatDomestic", // als MwSt-Konto für Inland
  VatEuPrivate = "VatEuPrivate", // als MwSt-Konto für EU
  ShippingDomestic = "ShippingDomestic", // als Versandkosten für Inland
  ShippingEuPrivate = "ShippingEuPrivate", // als Versandkosten für EU (Privatperson)
  ShippingEuBusiness = "ShippingEuBusiness", // als Versandkosten für Innergemeinschaftliche Lieferung
  ShippingNonEU = "ShippingNonEU", // als Versandkosten für nicht EU
  BankTransactionCosts = "BankTransactionCosts", // als Kosten für Geldverkehr
  AdvancePaymentsReceived = "AdvancePaymentsReceived", // als erhaltene Anzahlungen
  AdvancePaymentsPaid = "AdvancePaymentsPaid", // als geleistete Anzahlungen
}

export interface AccountingAccountResource {
  id: string;
  gid: string;
  is_important?: boolean;
  account_number: string;
  title: string;
  accounting_category: AccountingAccountCategoryEnum;
  type: AccountingAccountTypeEnum | null;
  vat_percent: string | null;
  vat_accounting_account_id: string | null;
  vat_accounting_account?: AccountingAccountResource;
  country_id: string | null;
  country: CountryResource | null;
  customer_id: string | null;
  supplier_id: string | null;
  variants: Pick<VariantResource, "id" | "title">[] | null;
  payment_methods: Pick<PaymentMethodResource, "id" | "title">[] | null;
  bankAccounts?: BankAccountResource[];
}

export enum AccountingAccountCategoryEnum {
  Depreciation = "Depreciation",
  FixedAssets = "FixedAssets",
  Expenditure = "Expenditure",
  Inventory = "Inventory",
  Income = "Income",
  Demands = "Demands",
  "Cash/Bank" = "Cash/Bank",
  NonDeductibleExpenses = "NonDeductibleExpenses",
  Private = "Private",
  Provisions = "Provisions",
  Other = "Other",
  Vat = "Vat",
  Liabilities = "Liabilities",
  InputTax = "InputTax",
}
